export const API_SERVER =
  window.RUNTIME_CONFIG?.BACKEND_SERVER ||
  process.env.REACT_APP_BACKEND_SERVER ||
  'http://localhost:8080/api';

let units = [
  { id: 7, label: '-' },
  { id: 6, label: 'm3' },
  { id: 5, label: 'LEL' },
  { id: 4, label: 'PSI' },
  { id: 3, label: '%' },
  { id: 2, label: 'C' },
  { id: 1, label: 'Bar' },
];

export const unitOptions = units;

let tagOptions = [
  { id: 1, label: 'RealHL' },
  { id: 2, label: 'RealLH' },
  { id: 3, label: 'DInt32HL' },
  { id: 5, label: 'Int16' },
  { id: 7, label: 'Word16' },
  { id: 8, label: 'DWord32' },
  { id: 9, label: 'LReal64' },
  { id: 10, label: 'Bool' },
  { id: 11, label: 'UDintHL' },
  { id: 12, label: 'UDintLH' },
  { id: 13, label: 'byteL' },
  { id: 14, label: 'byteH' },
  { id: 15, label: 'UInt' },
  { id: 17, label: 'SintH' },
  { id: 16, label: 'SintL' },
  { id: 18, label: 'UsintH' },
  { id: 19, label: 'UsintL' },
  { id: 20, label: 'Time' },
  { id: 21, label: 'CharL' },
  { id: 22, label: 'CharH' },
  { id: 23, label: 'String' },
  { id: 24, label: 'WString' },
  { id: 25, label: 'WChar' },
  { id: 4, label: 'DInt32LH' },
  { id: 6, label: 'Int16SWP' },
];

export const tagType = tagOptions;
